import { BaseField } from "./base";

export class MirrorField extends BaseField {
	constructor(field, form) {
		super(field, form);
		this.sourceField = this.field.dataset.sourceField;
		this.isEditable = this.field.dataset.editable === "true";
		this.isMirroring = true;
	}

	init() {
		if (!this.sourceField) {
			this.showError("You need to specify a source field");
			return;
		}

		this.field.readOnly = !this.isEditable;

		// If editable, add input listener to detect when user starts editing
		if (this.isEditable) {
			this.field.addEventListener("input", () => {
				if (this.isMirroring) {
					// User started editing, stop mirroring
					this.isMirroring = false;
					this.field.style.backgroundColor = "#fff"; // Remove mirror visual indicator
				}
			});
		}

		// Add form input listener to update when source changes
		this.form.addEventListener("input", (e) => {
			const sourceElement = this.form.querySelector(
				`[name="${this.sourceField}"]`,
			);
			if (
				sourceElement &&
				sourceElement === e.target &&
				this.isMirroring
			) {
				this.updateValue(sourceElement.value);
			}
		});

		// Get initial value
		const sourceElement = this.form.querySelector(
			`[name="${this.sourceField}"]`,
		);
		if (sourceElement) {
			this.updateValue(sourceElement.value);
		} else {
			this.showError(`Source field "${this.sourceField}" not found`);
		}
	}

	updateValue(value) {
		this.field.value = value;
		// Add subtle visual indicator that field is mirroring
		if (this.isMirroring) {
			this.field.style.backgroundColor = "#f8f9fa";
		}
	}

	showError(msg) {
		this.field.value = `Mirror field: ${msg}`;
		this.field.style.color = "red";
	}
}
